import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function h() {
  const a = JSON.parse(localStorage.getItem('zocs_auth') || 'null');
  return a ? { Authorization: `Bearer ${a.token}` } : {};
}
function clean(params) {
  const p = {};
  Object.entries(params || {}).forEach(([k, v]) => { if (v !== '' && v !== undefined && v !== null && v !== false) p[k] = v; });
  return p;
}
async function downloadBlob(path, params, fallbackName) {
  const r = await axios.get(`${API}${path}`, { headers: h(), params: clean(params), responseType: 'blob' });
  const cd = r.headers['content-disposition'] || '';
  const m = cd.match(/filename="([^"]+)"/);
  const url = URL.createObjectURL(r.data);
  const a = document.createElement('a');
  a.href = url; a.download = m ? m[1] : fallbackName; a.click();
  URL.revokeObjectURL(url);
}

export async function getBenchmarkBrands() {
  const r = await axios.get(`${API}/benchmark/brands`, { headers: h() });
  return r.data;
}
export async function getBenchmarkResults(params) {
  const r = await axios.get(`${API}/benchmark/results`, { headers: h(), params: clean(params) });
  return r.data;
}
export function exportBenchmarkResults(params) {
  return downloadBlob('/benchmark/results/export', params, 'benchmark.xlsx');
}
export async function startBenchmarkRun(body) {
  const r = await axios.post(`${API}/benchmark/runs`, body, { headers: h() });
  return r.data;
}
export async function getBenchmarkRuns(limit = 20) {
  const r = await axios.get(`${API}/benchmark/runs`, { headers: h(), params: { limit } });
  return r.data;
}
export async function getBenchmarkLinks(params) {
  const r = await axios.get(`${API}/benchmark/links`, { headers: h(), params: clean(params) });
  return r.data;
}
export function downloadLinksTemplate(brand) {
  return downloadBlob('/benchmark/links/template', { brand }, 'benchmark_links_template.csv');
}
export async function uploadBenchmarkLinks(file, mode) {
  const fd = new FormData();
  fd.append('file', file);
  const r = await axios.post(`${API}/benchmark/links/upload`, fd, { headers: h(), params: { mode } });
  return r.data;
}
